import { faArrowRightToLine } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '@hl/ui-components';
import { FC } from 'react';

import { HeaderIconContainer, HeaderWrapper } from './Header.styled';

export interface IHeaderProps {
  title?: string;
  minimize?: boolean;
  onHide: () => void;
}

export const Header: FC<IHeaderProps> = ({ onHide }) => {
  return (
    <HeaderWrapper>
      <HeaderIconContainer>
        <Icon
          icon={faArrowRightToLine}
          onClick={onHide}
          size={'sm'}
          title="Minimize AI Assistant"
        />
      </HeaderIconContainer>
    </HeaderWrapper>
  );
};
